const PageScene = {

    name: "Scene",

    //#region Template
    template: `
        <transition :name="sceneTransition" v-on:after-leave="transitionAfterLeave">
            <div class="transitionwrapper" v-if="!animating" >
                <div id="scene">

                    <!-- Background Component-->
                    <component  :is="getComponentConfiguration('BACKGROUND').componentName" 
                                :settings="getComponentConfiguration('BACKGROUND').settings"
                                :background="background"
                                :zoomBackground="backgroundZoomed"
                                @fullscreen="toggleFullscreen"
                                @closeAllContent="closeAllContent">
                    </component>

                    <!-- hotspots -->
                    <hotspot-render :hotspots="hotspots"  @goto="goto" :key="hotspotRenderKey"></hotspot-render>
                 

                    <!-- Component backdrop -->
                    <component  
                        :is="getComponentConfiguration('FOCUSED').componentName"  
                        :settings="getComponentConfiguration('FOCUSED').settings"
                        :isContentOpen="isContentOpen"
                        @closeAllContent="closeAllContent"></component> 

                    
                    <!-- Content Components: Dynamic render registered content components -->
                    <component v-for="(c, i) in content" :key="keyGen('cc', i)" class="component" :is="c.type" :contentId="c.id" v-if="c.open" @close="onCloseComponent"></component>

                    
                    <!-- Foreground Components -->
                    <div v-if="foreground.components" class="foreground-child-component-container">
                        <component v-for="(c,i) in foreground.components" :key="keyGen('fc', i)" :is="c.component" :config="c.props" :style="c.props.style" :class="c.props.cssClass" ></component>
                    </div>

                    <!-- UI Layer -->
                    <UIComponentRendere v-if="mounted" className="ui-layer" configRoot="UI"></UIComponentRendere>

                    <!-- messages: push-messages .... -->
                    <push-messages></push-messages>
                        
                </div><!-- /scene -->
            </div><!-- transitionwrapper -->
        </transition>
    `,
    //#endregion

    data() {
        return {
            animating: false,
            mounted: false,
            title: "",
            hotspots: [],
            resolutionDifference: 1,
            defaultHeight: 1080,
            background: {
                components: []
            },
            foreground: {
                components: []
            },
            autoOpenContent: [],
            defaultSceneTransition: 'changesceneZoom',
            sceneTransition: 'changesceneZoom',
            fullscreen: false,
            backgroundZoomed: false,

            /* Creates the definition for all registered content Components */
            content: touchKit.ComponentManager.getConfiguration(),

            // used to force the hotspots to rerender on user authorization change
            hotspotRenderKey: 0,

        }
    },

    mounted() {

        // allow the ui render to delay its own render untill we are sure the router is ready
        // otherwise the app.router.route throws an error.
        this.mounted = true;
        // a quick check on current screensize to scale scene to the size of the browser. 
        // also add reziser listener to scale entire scene continuously when the view is resized. 
        this.getScreenSize();
        window.addEventListener('resize', this.getScreenSize);

        this.eventHandlers = {
            "component-open": (id) => {
                if (id < 0) return;
                this.backgroundZoomed = touchKit.PageManager.getContent(id).data.zoom;
            },
            "component-close": (id) => {
                if (id < 0) return;
                setTimeout(() => {
                    this.backgroundZoomed = false
                }, this.getComponentConfiguration('BACKGROUND').zoomResetDelay || 1600);
            },
            "app-fullscreen-toggle": () => {
                this.toggleFullscreen();
            },
            "authorization-state-changed": () => {
                this.hotspotRenderKey = new Date().getTime();
            }
        };

        // bind events
        Object.keys(this.eventHandlers).forEach(event => {
            app.radio.$on(event, this.eventHandlers[event]);
        })


        // Checks that we are at a legal route,
        // if not we are redirected to the nearest legal route.
        var route = this.$router.currentRoute.params.pathMatch;
        var routeTest = touchKit.PageManager.isValidSceneRoute(route);
        if (!routeTest.valid) {
            route = routeTest.nearestValidRoute == "" ? "0" : routeTest.nearestValidRoute;
            this.$router.push(`/scene/${route}`)
            return;
        }

        this.findData(route, "", true);
    },

    beforeDestroy: function () {
        // remove event listeners
        window.removeEventListener('resize', this.getScreenSize);
        Object.keys(this.eventHandlers).forEach(event => {
            app.radio.$off(event, this.eventHandlers[event]);
        })
    },

    beforeRouteUpdate(to, from, next) {
        // Prevent the user from navigating to an illegal route.
        var routeTest = touchKit.PageManager.isValidSceneRoute(to.params.pathMatch);
        if (!routeTest.valid) {
            next(false);
            return;
        }

        // Remove any illegal media in the route.
        let hash = to.path
        let media = to.params.pathMatch.split(":").splice(1) || [];
        let illegalMedia = [];

        if (media.length) {
            // media.forEach(id => {
            //     if (!this.checkToPageIsWhiteListContent(to.path, id)) {
            //         illegalMedia.push(id);
            //     }
            // });

            illegalMedia.forEach(contentId => {
                hash = hash.replace(":" + contentId, "");
            })

            if (illegalMedia.length) {
                next(hash);
            }
            else {
                this.findData(to.params.pathMatch, from.params.pathMatch);
                next();
            }
        } else {
            this.findData(to.params.pathMatch, from.params.pathMatch);
            next();
        }
    },

    watch: {
        "animating": function (value, oldValue) {
            if (!value) {
                app.radio.$emit("scene-ready")
            }
        }
    },

    computed: {
        isContentOpen() {
            //check to see if a content component is open.
            return this.$route.path.includes(':')
        },
    },

    methods: {
        // responsibility: mixin
        keyGen(prefix, index) {
            return prefix + "-" + index;
        },
        
        transitionAfterLeave() {
            this.animating = false;
            // auto open on new page.
            if (!/\:/.test(this.$router.currentRoute.path))
                this.autoOpenContent.forEach(id => this.displayMedia(id));
        },

        // responsibility: ComponentManager
        getComponentConfiguration(name) {
            return touchKit.utils.objCopy(config[name]);
        },
      
        getScreenSize() {

            // NOTE: Scaling handler. uses css transform: scale on the #app id to scale the entire scene.
            // The math to determine how much scale to apply to the scene. 
            // It will make the app as big as it can be while maintaining its aspect ratio. The app will be centered.

            let app = document.getElementById("app");

            // NOTE: Default settings
            var aspectRatioOptions = {
                centerVertically: false,
                centerHorizontically: true
            };

            // NOTE: Get options if defined in config.js and override defaults.
            if (config && config.SCREEN_SIZE_OPTIONS) {
                if (typeof (config.SCREEN_SIZE_OPTIONS.centerVertically) !== 'undefined') {
                    aspectRatioOptions.centerVertically = config.SCREEN_SIZE_OPTIONS.centerVertically;
                }
                if (typeof (config.SCREEN_SIZE_OPTIONS.centerVertically) !== 'undefined') {
                    aspectRatioOptions.centerHorizontically = config.SCREEN_SIZE_OPTIONS.centerHorizontically;
                }
            }

            var windowResolution = {
                width: window.innerWidth,
                height: window.innerHeight
            };

            var appResolution = {
                width: app.offsetWidth,
                height: app.offsetHeight
            }

            var windowAspectRatio = windowResolution.width / windowResolution.height;
            var appAspectRatio = appResolution.width / appResolution.height;

            var windowAspectRatioIsTallerThanApp = (windowAspectRatio > appAspectRatio);

            if (windowAspectRatioIsTallerThanApp) {
                // NOTE: Window is taller than app
                // NOTE: Resize app based on height
                var heightDifference = windowResolution.height / appResolution.height;
                app.style.transform = ("scale(" + heightDifference + ")");
            }
            else {
                // NOTE: Window is wider than app
                // NOTE: Resize app based on width
                var widthDifference = windowResolution.width / appResolution.width;
                app.style.transform = ("scale(" + widthDifference + ")");
            }


            // NOTE: Center the app container on both axis

            var appClientRect = app.getBoundingClientRect();
            var appResolutionScaled = {
                width: appClientRect.width,
                height: appClientRect.height
            }

            var appOffset = {
                x: 0,
                y: 0
            };

            if (aspectRatioOptions.centerHorizontically && (appResolutionScaled.width < windowResolution.width)) {
                appOffset.x = (windowResolution.width - appResolutionScaled.width) / 2;
            }

            if (aspectRatioOptions.centerVertically && (appResolutionScaled.height < windowResolution.height)) {
                appOffset.y = (windowResolution.height - appResolutionScaled.height) / 2;
            }

            app.style.transformOrigin = 'top left';
            app.style.left = appOffset.x + 'px';
            app.style.top = appOffset.y + 'px';
            app.style.margin = '0';
        },

        setTransformOrigin(x, y) {
            this.$el.style.transformOrigin = `${x}px ${y}px`;
        },

        toggleFullscreen() {
            this.fullscreen = !this.fullscreen;
            this.fullscreen ? touchKit.utils.fullScreenEnable() : touchKit.utils.fullScreenDisable();
        },

        closeAllContent() {
            // Check route string for first ':' to see if any content components are open. 
            // if so, close them.
            if (this.$router.currentRoute.path.includes(':')) {
                var url = this.$router.currentRoute.path;
                var i = url.indexOf(':');
                var closed = url.substring(i, url.length);

                url = url.substring(0, i);

                this.$router.push(url);


            }

            //no active hotspots when background is clicked
            this.activeHotspot = null;
            app.radio.$emit("scene-closing-all-components")
        },

        // responsibility: app.router
        sanitizeRoute(route) {
            // replace any media from the route.
            return route.replace(/:.*/, "");
        },

        // responsibility: app.router
        routesEqual(a, b) {
            return this.sanitizeRoute(a) === this.sanitizeRoute(b);
        },

        findData(route, oldRoute, skipAnimation = false) {
            if (skipAnimation) {
                // The pages scene skipped animation, this is the initial scene
                app.radio.$emit("scene-ready")
            }

            // 
            // Page Change
            //
            if (!this.routesEqual(route, oldRoute)) {
                var content = touchKit.PageManager.findNode(this.sanitizeRoute(route));
                this.hotspots = content.data.hotspots;

                var page = touchKit.PageManager.getScene(content.data.id);

                this.autoOpenContent = page.autoOpenContent || [];
                this.background = {
                    ...page.background
                }
                this.foreground = {
                    ...page.foreground
                }

                this.sceneTransition = page.hasOwnProperty('scenetransition') ? page.scenetransition : this.defaultSceneTransition;

                // reset component states.
                this.closeComponents();

                if (!skipAnimation) {
                    this.animating = true;
                }
            }

            // 
            // media 
            // 
            let media = route.split(":").splice(1) || [];
            media.forEach(id => this.displayMedia(id));

            // closing all other components then 
            // the ones defined in the media array.
            this.closeComponents(media);

            // if no old route we just loaded the page.
            if (oldRoute === "") {
                if (!/\:/.test(this.$router.currentRoute.path)){
                    setTimeout(() => { this.autoOpenContent.forEach(id => this.displayMedia(id)) }, 1000)
                }
            }
        },

        displayMedia(id) {

            if (!this.isWhiteListContent(id)) return app.logging.log("PageScene", `ignoring content ${id}, its not on the whitelist.`);

            var content = touchKit.PageManager.getContent(id);
            if (!content) return app.logging.error("PageScene", `cannot find content with id ${id}`);


            var componentType = content.type.toLowerCase();

            if (this.hasComponentType(componentType)) {

                var component = this.getComponentsByType(componentType);

                // Content already open
                if (this.getComponentByContentId(content.id)) {
                    return;
                }

                if (component.singleton && !component.length) {
                    component.id = content.id;
                    component.open = true;

                    app.radio.$emit("component-open", content.id);
                }
                else {
                    var numComponentOfType = component.length;
                    var numComponentsOpen = component.filter(o => o.open).length;
                    var anyAvailableComponents = numComponentsOpen < numComponentOfType
                    if (anyAvailableComponents) {
                        // reuse a component to display this content
                        var target = component.find(o => !o.open && (o.id !== content.id));
                        target.id = content.id;
                        target.open = true;

                        app.radio.$emit("component-open", content.id);
                    } else {
                        // create a new component of type.
                        this.content.push(touchKit.ComponentManager.configureComponent(componentType, content.id, true));
                    }
                }
            }
            else {
                console.warn(`Can't find no component of type: ${componentType}`);
            }
        },

        hasComponentType(type) {
            return this.content.some(o => o.type.toLowerCase() === type);
        },

        getComponentsByType(type) {
            var result = this.content.filter(o => o.type.toLowerCase() === type);
            if (result.length == 1 && result[0].singleton)
                return result[0];
            return result;
        },

        getComponentByContentId(id) {
            return this.content.find(o => o.id == id);
        },

        /**
         * Closes All Components except thoes who is displaying the content with the content ids in the ignore list.
         * @param {Array<string>} ignoreList 
         */
        closeComponents(ignoreList = []) {
            this.content.forEach(component => {
                var cid = component.id.toString();
                if (!ignoreList.includes(cid)) {
                    component.open = false
                    component.id = -1;
                }
            })
        },

        onCloseComponent(contentId) {
            var o = this.content.find(c => c.id === contentId)
            o.open = false;
            o.id = -1;
            this.removeComponentContentRoute(contentId)
            app.radio.$emit("component-close");
        },

        closeComponentById(id) {
            var target = this.getComponentByContentId(id);
            if (target) {
                target.open = false;
                app.radio.$emit("component-close", id);
            } else {
                app.logging.error("PageScene", "closeComponentById, cant find component id:", id);
            }
        },

        removeComponentContentRoute(id) {
            app.radio.$emit("component-close", id);
            var route = app.vm.$route.fullPath.replace(`:${id}`, "");
            this.$router.push(route)
        },

        goto(hotspot) {
            // 
            //  navigation 
            // 
            if (hotspot.hotspots) {
                this.setTransformOrigin(hotspot.x, hotspot.y);
                var newRoute = this.$route.path.replace(/\:.*/, "") + "/" + hotspot.id;
                if (hotspot.openChildContent && hotspot.openChildContent.length) {
                    hotspot.openChildContent.forEach(contentId => {
                        newRoute += `:${contentId}`;
                    })
                }
                this.$router.push(newRoute);
            }
            //
            // show content
            //
            else {
                // if the current content is not already showing.
                if (!this.isContentActive(hotspot.id)) {
                    var newRoute = app.vm.$route.fullPath + `:${hotspot.id}`

                    // check what type of content the link is attempting to open
                    var content = touchKit.PageManager.getContent(hotspot.id);
                    var contentType = content.type.toLowerCase();
                    var component = this.getComponentsByType(contentType) || {};

                    // If the contentType is a handler, its not a visible component (like an external link etc.)
                    // and we can just execute the handler and do nothing else.
                    if (touchKit.ComponentManager.isHandler(contentType)) {
                        touchKit.ComponentManager.executeHandler(contentType, content.data);
                    }
                    else {
                        if (component.open && component.singleton && component.id !== hotspot.id) {
                            newRoute = newRoute.replace(`:${component.id}`, "");
                        }

                        this.$router.push(newRoute);
                    }
                } else {
                    //  the route already contains the component lets close it
                    this.closeComponentById(hotspot.id);
                    this.removeComponentContentRoute(hotspot.id);
                }
            }
        },


        isWhiteListContent(id) {
            return app.data.content.some(o => Number(o.id) === Number(id))

        },

        // content util
        checkToPageIsWhiteListContent(strRoute, contentId) {
            const route = strRoute.replace("/scene/", "");
            const toPageContent = touchKit.PageManager.findNode(this.sanitizeRoute(route)).data.hotspots
            return toPageContent.some(o => {
                return o.id.toString() === contentId.toString() && !o.hasOwnProperty("hotspots");
            })
        },

        // content util
        isContentActive(id) {
            // if the hotspot id is to be found in the content part of the route (:id)
            // then its safe to assume that the hotspot is active.
            // this is for a specific content id. see isContentOpen() for a generic check if any content is open.
            return this.$route.path.includes(":" + id);
        },
    }
}